module.exports = __webpack_public_path__ + "img/selected1-min.0d1bd5d5.png";